export enum ErrorNamesEnum {
  AbortError = 'AbortError',
}
